<template>
  <div class="addAddress absolute">
<!--    <img-->
<!--        src="@assets/images/exchangePrompt.jpg"-->
<!--        alt=""-->
<!--        style="width: 100%;"-->
<!--    />-->
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div class="name">卡号</div>
        <input
          type="text"
          placeholder="请输入卡号"
          v-model="userCard.number"
          required
        />
      </div>

      <div class="item acea-row row-between-wrapper">
        <div class="name">密码</div>
        <input
          type="text"
          placeholder="请输入密码"
          v-model="userCard.password"
          required
        />
      </div>
    </div>

    <div class="keepBnt bg-color-red" @click="submit">兑换</div>
    <div
      class="keepBnt bg-color-red"
      style="margin: 0 auto 0 auto;"
      @click="$router.push('/user/cardBag')"
    >
      我的卡包
    </div>
    <div class="keepBnt bg-color-red" @click="myConversion">我的兑换</div>
    <div style="margin-top:20px;">
      <div style="margin-left:10px;margin-right:5px;">
        兑换须知：<br />
        1、兑换卡仅能使用一次，不找零，不退换，不能兑换现金；<br />
        2、发货时间为24-48小时；<br />
        3、兑换商品均包邮发货，港澳台、新疆、西藏、内蒙及偏远地区暂不支持发货；<br />
        4、客服热线：18612136323（微信同号），上班时间： 9:00-19:00 <br />
        <br />
        <span style="color: red">春节物流停运：2月9日—2月26日假期可正常兑换，只接单不发货，2月27日起恢复陆续发货，敬请谅解！！</span><br />
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import { postGoodsCard } from "@api/user";
import attrs, { required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
export default {
  data() {
    return {
      show2: false,
      model2: "",
      id: 0,
      userCard: { is_default: 0 },
      address: {},
      a: false
    };
  },
  mounted: function() {
    let id = this.$route.params.id;
    this.id = id;
    document.title = !id ? "兑换礼品卡" : "修改礼品卡";
  },
  methods: {
    async submit() {
      let number = this.userCard.number,
        password = this.userCard.password;
      try {
        await this.$validator({
          number: [
            required(required.message("卡号")),
            attrs.range([1, 16], attrs.range.message("卡号"))
          ],
          password: [
            required(required.message("密码")),
            attrs.range([1, 16], attrs.range.message("密码"))
          ]
        }).validate({ number, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      try {
        var that = this;
        var data = {
          id: that.id,
          number: number,
          password: password
        };
        postGoodsCard(data)
          .then(response => {
            console.log(response);

            if (response.data.is_optional_card > 0) {
              that.$router.replace({
                path: "/user/active_exchange_goods/",
                query: {
                  u: number,
                  p: password,
                  t: response.data.group_id
                }
              });
            } else {
              that.$router.replace({
                path: "/user/active_exchange_only_goods",
                query: {
                  u: number,
                  p: password,
                  t: response.data.group_id
                }
              });
            }
          })
          .catch(e => {
            that.$dialog.toast({ mes: e.msg });
          });
      } catch (e) {
        this.$dialog.toast({ mes: `兑换失败：${e.msg}` });
      }
    },

    myConversion() {
      this.$router.push("/user");
    }
  }
};
</script>
